import { render, staticRenderFns } from "./LegendaTotalGeralEPorFilial.vue?vue&type=template&id=279cdb40"
import script from "./LegendaTotalGeralEPorFilial.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendaTotalGeralEPorFilial.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports